import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Enlightenment_&_Revolutions_-_American_Revolution.png';

function HistoryPageAmericanRevolution() {
  return (
    <TopicPage
      topicKey="American Revolution"
      title="History: American Revolution"
      backgroundImage={bg}
      startRoute="/History-American-Revolution-Go"
      scrollLabels={[
        "Causes and Conflicts",
        "Declaration of Independence",
        "Aftermath and Global Impact"
      ]}
      backRoute="/history-age-of-revolutions"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageAmericanRevolution;
